import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Preloader from "@/components/Preloader";
import Hero from "@/components/Hero";
import BridgeSection from "@/components/BridgeSection";
import Directions from "@/components/Directions";
import Stakeholders from "@/components/Stakeholders";
import Process from "@/components/Process";
import Sectors from "@/components/Sectors";
import Confidentiality from "@/components/Confidentiality";
import Opportunities from "@/components/Opportunities";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function Home() {
  const [intro, setIntro] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setIntro(false), 2200);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="bg-obsidian min-h-screen" data-testid="home-page">
      <Preloader active={intro} />
      <Navbar />
      <main>
        {!intro && <Hero />}
        <BridgeSection />
        <Directions />
        <Stakeholders />
        <Process />
        <Sectors />
        <Confidentiality />
        <Opportunities />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
